import { render, staticRenderFns } from "./HeadingDetailsImage.vue?vue&type=template&id=59fd7d0e&"
import script from "./HeadingDetailsImage.vue?vue&type=script&lang=js&"
export * from "./HeadingDetailsImage.vue?vue&type=script&lang=js&"
import style0 from "./HeadingDetailsImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports